/**
 * Carrega ECharts via CDN (mesma URL que buildChartExportInnerHtml).
 * Evita import('echarts') no bundle — o build do Vite não precisa resolver o pacote npm.
 * Usado apenas pelo palco (RenderMadriChart).
 */
const ECHARTS_SRC = 'https://cdn.jsdelivr.net/npm/echarts@5.5.1/dist/echarts.min.js';

export function loadMadriEcharts() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('loadMadriEcharts: sem window'));
  }
  const w = window;
  if (w.echarts) {
    return Promise.resolve(w.echarts);
  }
  return new Promise((resolve, reject) => {
    const entry = { resolve, reject };
    if (!w.__madriEchartsWaiters) {
      w.__madriEchartsWaiters = [];
    }
    w.__madriEchartsWaiters.push(entry);
    if (w.__madriEchartsScriptLoading) {
      return;
    }
    w.__madriEchartsScriptLoading = true;
    const s = document.createElement('script');
    s.src = ECHARTS_SRC;
    s.async = true;
    s.onload = () => {
      w.__madriEchartsScriptLoading = false;
      const waiters = w.__madriEchartsWaiters || [];
      w.__madriEchartsWaiters = null;
      const e = w.echarts;
      waiters.forEach((wt) => {
        if (e) wt.resolve(e);
        else wt.reject(new Error('ECharts indisponível após CDN'));
      });
    };
    s.onerror = () => {
      w.__madriEchartsScriptLoading = false;
      const waiters = w.__madriEchartsWaiters || [];
      w.__madriEchartsWaiters = null;
      const err = new Error('Falha ao carregar ECharts (CDN)');
      waiters.forEach((wt) => wt.reject(err));
    };
    document.head.appendChild(s);
  });
}
